module.exports = __webpack_public_path__ + "static/media/lowell.png";